import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { axiosProvider } from '@/store/provider';
import { refreshTokenInterceptorProvider } from '@/store/provider/intercept';

export interface UserAccessTogglePayload {
  username: string;
}

export interface UpdateEmailPayload {
  username: string;
  newEmail: string;
}

export class UserManagementService {
  private request: AxiosInstance;

  constructor() {
    this.request = axiosProvider('auth', {}, {
      response: [refreshTokenInterceptorProvider()]
    });
  }

  async enableUser(cognitoEmail: string, config: AxiosRequestConfig = {}) {
    const payload: UserAccessTogglePayload = {
      username: cognitoEmail
    };
    
    return this.request.post('enable-user', payload, config);
  }

  async disableUser(cognitoEmail: string, config: AxiosRequestConfig = {}) {
    const payload: UserAccessTogglePayload = {
      username: cognitoEmail
    };
    
    return this.request.post('disable-user', payload, config);
  }

  async updateEmail(currentEmail: string, newEmail: string, config: AxiosRequestConfig = {}) {
    const payload: UpdateEmailPayload = {
      username: currentEmail,
      newEmail: newEmail
    };
    
    return this.request.post('update-email', payload, config);
  }
}

const userManagementService = new UserManagementService();
export { userManagementService };
